import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'reflexbox'
import CSSModules from 'react-css-modules'

import FulcrumCollapse from 'components/fulcrum/collapse/Collapse'
import IconButton from './CollapseIconButton'
import styles from './styles.scss'

class Collapse extends Component {
  constructor(props){
    super(props)
    this.state = {
      collapse: (props.collapse) ? true : false
    }
  }

  static propTypes = {
    collapse: PropTypes.bool
  }

  toggleCollapse = () => {
    this.setState({collapse: !this.state.collapse})
  }

  render(){
    return (
      <div styleName='collapseContainer'>
        <Flex justify='space-between' align='center'>
          <span styleName='collapseTitleSpan'>
            {this.props.label}
          </span>
          <IconButton
            onClick={this.toggleCollapse}
            collapse={this.state.collapse}
          />
        </Flex>
        <FulcrumCollapse collapse={this.state.collapse}>
          { this.props.children }
        </FulcrumCollapse>
      </div>
    )
  }
}

export default CSSModules(Collapse, styles)
